
import { Column } from "../objects/column";
import { UserTeam } from "../objects/userTeam";
import { UserTeamListConfiguration, UserTeamListCriteria, UserTeamListFiltersCriteria } from "../objects/userTeamList";

export const USER_TEAM_COLUMN: Column[] = [
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'countries',
        field_name: 'COUNTRIES',
        checked: true,
        order_by: 'countries',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'events',
        field_name: 'EVENTS',
        checked: false,
        order_by: 'events',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'users',
        field_name: 'USERS',
        checked: false,
        order_by: 'users',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

export const EMPTY_USER_TEAM_FILTERS: UserTeamListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
    countries: [],
    events: [],
    users: []
};


export const EMPTY_USER_TEAM_LIST_CRITERIA: UserTeamListCriteria = {
    limit: 50,
    page: 0,
    order_by: 'modified_date',
    order: 'desc',
    filters: EMPTY_USER_TEAM_FILTERS,
    search: '',
};

export const EMPTY_USER_TEAM_LIST_CONFIGURATION: UserTeamListConfiguration = {
    columns: USER_TEAM_COLUMN,
    preferences: []
};


export const EMPTY_USER_TEAM: Partial<UserTeam> = {
    team_name: "",
    countries: [],
    event_sites: [],
    users: [],
};


export const USER_TEAM_MODULE = 'USER_TEAM';